import AccidentTravailDateEffet from '@/generated/controls/accidentTravail/AccidentTravailDateEffet.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: AccidentTravailDateEffet
})
